// 약관 동의 — 소셜 신규 가입 직후처럼 동의를 아직 받지 못한 계정(PENDING_TERMS)용
// 동의 완료 전에는 서비스 기능을 쓸 수 없다(백엔드가 403 TERMS_AGREEMENT_REQUIRED로 차단).
import { useEffect, useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { authApi, type TermsItem } from "@taplink/web-shared";
import { ApiError } from "@taplink/web-shared";
import { useAuth } from "@taplink/web-shared";
import { TermsCheckList, requiredSatisfied, toAgreements } from "../components/TermsCheckList.tsx";

export function TermsAgreementPage() {
  const navigate = useNavigate();
  const { refresh, logout } = useAuth();

  const [terms, setTerms] = useState<TermsItem[]>([]);
  const [checked, setChecked] = useState<Record<string, boolean>>({});
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    authApi.terms().then(setTerms).catch(() => setError("약관을 불러오지 못했습니다."));
  }, []);

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await authApi.agreeTerms(toAgreements(terms, checked));
      await refresh();
      navigate("/", { replace: true });
    } catch (e) {
      setError(e instanceof ApiError ? e.message : "동의 처리에 실패했습니다.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="page">
      <div className="card">
        <h1>약관 동의</h1>
        <p className="subtitle">서비스 이용을 위해 아래 약관에 동의해 주세요.</p>

        {error && <div className="alert alert-error" role="alert">{error}</div>}

        <form onSubmit={onSubmit}>
          <TermsCheckList
            terms={terms}
            checked={checked}
            onChange={(code, value) => setChecked((prev) => ({ ...prev, [code]: value }))}
          />

          <div style={{ marginTop: "1.25rem" }}>
            <button
              type="submit"
              className="btn-primary btn-block"
              disabled={!requiredSatisfied(terms, checked) || submitting}
            >
              {submitting ? "처리 중…" : "동의하고 시작하기"}
            </button>
          </div>
        </form>

        <div className="footer-links">
          <button type="button" className="btn-link" onClick={() => { logout(); navigate("/login"); }}>
            로그아웃
          </button>
        </div>
      </div>
    </main>
  );
}
